"use strict";
/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withIncreasedHorizontalPosition = exports.withHorizontalPosition = exports.withNoEndDotInfo = exports.withZeroDotInfo = exports.withDotInfo = exports.withIncreasedIndentation = exports.withZeroIndentation = exports.withIndentation = void 0;
var withIndentation = function (localIndentation) { return function (config) { return (__assign(__assign({}, config), { localIndentation: localIndentation })); }; };
exports.withIndentation = withIndentation;
exports.withZeroIndentation = (0, exports.withIndentation)(0);
var withIncreasedIndentation = function (indentationIncrease) { return function (config) { return (__assign(__assign({}, config), { localIndentation: config.localIndentation + indentationIncrease })); }; };
exports.withIncreasedIndentation = withIncreasedIndentation;
var withDotInfo = function (_a) {
    var shouldStartWithDot = _a.shouldStartWithDot, shouldEndWithDot = _a.shouldEndWithDot;
    return function (config) { return (__assign(__assign({}, config), { shouldStartWithDot: shouldStartWithDot, shouldEndWithDot: shouldEndWithDot })); };
};
exports.withDotInfo = withDotInfo;
var withZeroDotInfo = function (config) { return (__assign(__assign({}, config), { shouldStartWithDot: false, shouldEndWithDot: false })); };
exports.withZeroDotInfo = withZeroDotInfo;
var withNoEndDotInfo = function (config) { return (__assign(__assign({}, config), { shouldEndWithDot: false })); };
exports.withNoEndDotInfo = withNoEndDotInfo;
var withHorizontalPosition = function (horizontalPosition) { return function (config) { return (__assign(__assign({}, config), { horizontalPosition: horizontalPosition })); }; };
exports.withHorizontalPosition = withHorizontalPosition;
var withIncreasedHorizontalPosition = function (horizontalPositionIncrease) { return function (config) { return (__assign(__assign({}, config), { horizontalPosition: config.horizontalPosition + horizontalPositionIncrease })); }; };
exports.withIncreasedHorizontalPosition = withIncreasedHorizontalPosition;
